import {
  Configuration,
  ClaimCentersApi,
  GetClaimCentersRequest,
  ClaimCenterWithBookables,
} from '@interaction-gaming/game-data-service-browser-client'

type APIConfig = {
  apiKey: string
  basePath: string
}

let CLAIM_CENTERS_API: ClaimCentersApi

const getClaimCentersApi = () => {
  if (!CLAIM_CENTERS_API) {
    throw new Error('Claim centers API has yet to be defined')
  }
  return CLAIM_CENTERS_API
}

const configureApi = (config: APIConfig) => {
  const configuration = new Configuration({
    ...config,
  })
  CLAIM_CENTERS_API = new ClaimCentersApi(configuration)
}

const getClaimCenters = async (): Promise<ClaimCenterWithBookables[]> => {
  const api = getClaimCentersApi()
  const request: GetClaimCentersRequest = {}

  return (await api.getClaimCenters(request)).claimCenters
}

export const GameDataServiceAPI = {
  configureApi,
  getClaimCenters,
}
